/* eslint-disable */
// src/ui/skins/typeBlocks.js

import { Box } from "@mui/material";
import GlobalStyles from "@mui/material/GlobalStyles";
import MDTypography from "components/MDTypography";

export const CURVE = 10;
export const RADII = { outer: CURVE, inner: CURVE, table: CURVE };
export const FONTS = { typeChip: 18, name: 16, meta: 14.5 };

export const TYPE_COLORS = {
  Rockola:     { bg: "#FFF7F4", border: "#D86B5B", tableBg: "#FFF4F0", headBg: "#FDEAE5" },
  Pool:        { bg: "#F6FBFA", border: "#1EA89B", tableBg: "#F2FBF9", headBg: "#E7F6F4" },
  Tejo:        { bg: "#FAF7FF", border: "#8F6AF5", tableBg: "#F7F3FF", headBg: "#EFE8FF" },
  Peluchera:   { bg: "#FFF9F0", border: "#B88200", tableBg: "#FFF8E8", headBg: "#F3F5F7" },
  Tragamoneda: { bg: "#F8FAFF", border: "#5B7CF3", tableBg: "#F7F9FF", headBg: "#EEF3FF" },
  Alquilada:   { bg: "#FBFBFC", border: "#9AA3AD", tableBg: "#F9FAFB", headBg: "#F3F5F7" },
  Default:     { bg: "#FAFAFA", border: "#BDBDBD", tableBg: "#FFFFFF", headBg: "#F5F5F5" },
};

/* ===== Estilos de bloque por tipo ===== */
export const getTypeStyle = (type) => {
  const c = TYPE_COLORS[type] || TYPE_COLORS.Default;
  return {
    position: "relative",
    backgroundColor: `${c.border}26`,
    border: `1px solid ${c.border}5C`,
    padding: "10px 12px 12px",
    borderRadius: `${RADII.outer}px !important`,
    overflow: "hidden",
    mb: 2,
  };
};

export const getInnerPanelStyle = (type) => {
  const c = TYPE_COLORS[type] || TYPE_COLORS.Default;
  return {
    backgroundColor: c.bg,
    padding: "8px 8px 10px",
    borderRadius: `${RADII.inner}px !important`,
    overflow: "hidden",
  };
};

/* Opcional: skin para DataTable dentro del bloque */
export const getTableSkin = (type) => {
  const c = TYPE_COLORS[type] || TYPE_COLORS.Default;
  return {
    ".MuiCard-root": { backgroundColor: "transparent", boxShadow: "none" },
    ".MuiTableContainer-root": {
      backgroundColor: c.tableBg,
      border: `1px solid ${c.border}33`,
      borderRadius: `${RADII.table}px !important`,
      overflow: "hidden",
      "& table": {
        tableLayout: "fixed",   // ← fuerza el reparto por % y evita “bailes”
        width: "100%",
      },
      "& table thead th, & table tbody td": {
        padding: "8px 10px",    // ← padding consistente
        verticalAlign: "top",
        whiteSpace: "nowrap",
        overflow: "hidden",
        textOverflow: "ellipsis",
      },
      "& table thead th, & table tbody td": { textAlign: "left !important" },
      "& table thead th > *, & table tbody td > *": {
        textAlign: "left !important",
        justifyContent: "flex-start !important",
      },
    },
    ".MuiTableHead-root .MuiTableRow-root .MuiTableCell-root": {
      backgroundColor: c.headBg,
      fontWeight: 600,
    },
  };
};

/* Radios consistentes en una página (pasás el rootId de esa vista) */
export function TypeBlocksGlobalStyles({ rootId = "#type-blocks-root" }) {
  return (
    <GlobalStyles
      styles={{
        [`${rootId} .vtb`]:        { borderRadius: `${RADII.outer}px !important`, overflow: "hidden" },
        [`${rootId} .vtb-inner`]:  { borderRadius: `${RADII.inner}px !important`, overflow: "hidden" },
        [`${rootId} .vtb .MuiTableContainer-root`]: {
          borderRadius: `${RADII.table}px !important`, overflow: "hidden",
        },
      }}
    />
  );
}

/* Encabezado tipo chip (+opc. chip de estado “Alquiladas”) */
// chips internos SIN border-radius propio y SIN margen entre sí.
//         El radio y el clip lo maneja el contenedor, así quedan pegados.
export function TypeChipsHeader({ type, typeLabel, rightChip }) {
  return (
    <Box
      sx={{
        mb: 0.5,
        display: "inline-flex",
        alignItems: "center",
        borderRadius: CURVE,
        overflow: "hidden",
        gap: 0,
        lineHeight: 1,
      }}
    >
      <Box
        component="span"
        sx={{
          display: "inline-flex",
          alignItems: "center",
          px: 1.25,
          py: 0.35,
          background: TYPE_COLORS[type]?.border || TYPE_COLORS.Default.border,
          color: "#fff",
          fontWeight: 700,
          lineHeight: 1.15,
          fontSize: FONTS.typeChip,
          borderRadius: 0,
          m: 0,
        }}
      >
        {typeLabel}
      </Box>
      {rightChip && (
        <Box
          component="span"
          sx={{
            display: "inline-flex",
            alignItems: "center",
            px: 1.25,
            py: 0.35,
            background: TYPE_COLORS.Alquilada.border,
            color: "#fff",
            fontWeight: 700,
            lineHeight: 1.15,
            fontSize: FONTS.typeChip,
            borderRadius: 0,
            m: 0,
          }}
        >
          {rightChip}
        </Box>
      )}
    </Box>
  );
}

/* Contenedor de bloque por tipo */
export function TypeBlock({ type, header, children }) {
  return (
    <Box sx={getTypeStyle(type)} className="vtb">
      {header}
      <Box sx={getInnerPanelStyle(type)} className="vtb-inner">
        {children}
      </Box>
    </Box>
  );
}

/* Tipos de texto (nombre + metadatos en una línea) */
export function MachineName({ children }) {
  return (
    <MDTypography variant="button" fontWeight="medium" sx={{ whiteSpace: "nowrap", fontSize: `${FONTS.name/16}rem` }}>
      {children}
    </MDTypography>
  );
}
export function MachineMeta({ children }) {
  return (
    <MDTypography variant="caption" color="text"
      sx={{ whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis", fontSize: `${FONTS.meta/16}rem` }}>
      {children}
    </MDTypography>
  );
}

/* Separador “•” listo para inline */
export const dotSep = <span style={{ opacity: 0.55, userSelect: "none" }}>•</span>;
